import { Action, createReducer, on } from '@ngrx/store';
import {ErrorModel, Profile, UserInfo} from '@tekman/onmat/models';
import * as ProfileActions from './profile.actions';

export const PROFILE_FEATURE_KEY = 'profile';

export interface State {
  profile?: Profile | null;
  error?: ErrorModel;
  userInfo?: UserInfo | null;
  loaded?: boolean;
  logout?: boolean;
}

export interface ConfigurationPartialState {
  readonly [PROFILE_FEATURE_KEY]: State;
}

export const initialState: State = {
  profile: null,
  error: null,
  userInfo: null,
  loaded: false,
  logout: false,
};

const profileReducer = createReducer(
  initialState,
  on(ProfileActions.authSuccess, state => ({
    ...state,
    loaded: true,
  })),
  on(ProfileActions.authFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: false,
  })),
  on(ProfileActions.loadProfileSuccess, (state, { profile, userInfo }) => ({
    ...state,
    profile,
    userInfo,
    loaded: true,
  })),
  on(ProfileActions.loadProfileFailure, ProfileActions.pageNotFound, (state, { error }) => ({
    ...state,
    error,
    loaded: false,
  })),
  on(ProfileActions.removeProfile, state => ({
    ...state,
    profile: null,
    userInfo: null,
    logout: true,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return profileReducer(state, action);
}
